import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { Observable } from 'rxjs/Observable';
import { Utility } from '../../common/utility';
import { PatientUrl } from '../../shared/urls/patient.url';
import { ConsultationUrl } from '../../shared/urls/consultation.url';
import { InvoiceUrl } from '../../shared/urls/invoice.url';
@Injectable()
export class ConsultationHistoryService {
    constructor(public baseService: BaseService) {
    }

    getConsultationHistory(patientId): Observable<any> {
        let url = Utility.stringFormat(PatientUrl.GET_PATIENT_CONSULTATIONS, [patientId]);
        return this.baseService.getData(url);
    }
    getTravelAgendaCompleteHistory(ids: any[]) {
        const url = ConsultationUrl.GET_TRIP_INFORMATION_COMPLETED_HISTORY;
        return this.baseService.postData(url, ids);
    }
    getTravelAgenda(ConsultationId) {
        const url = Utility.stringFormat(ConsultationUrl.GET_TRIP_INFORMATION, [ConsultationId]);
        return this.baseService.getData(url);
    }

    getInvoiceHistory(ids: any[]) {
        const url = ConsultationUrl.GET_CONSULTATION_INVOICE;
        return this.baseService.getData(url, ids);
    }

    getMedicalConditionCompleteHistory(ids: any[]) {
        const url = ConsultationUrl.GET_CONSULTATION_MEDICAL_CONDITION_COMPLETED_HISTORY;
        return this.baseService.postData(url, ids);
    }
    getMedicalCondition(ConsultationId) {
        
        const url = Utility.stringFormat(ConsultationUrl.GET_CONSULTATION_MEDICAL_CONDITION, [ConsultationId]);
        return this.baseService.getData(url);
    }

    getPatientVacines(ConsultationId) {
        const url = Utility.stringFormat(ConsultationUrl.GET_PRESCRIBE_VACCINATION, [ConsultationId]);
        return this.baseService.getData(url);
    }

    getPrescriptionCompleteHistory(ids: any[]) {
        const url = ConsultationUrl.GET_PATIENT_PRESCRIPTION_COMPLETED_HISTORY;
        return this.baseService.postData(url, ids);
    }

    getPrescription(ConsultationId) {
        const url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_PRESCRIPTION, [ConsultationId]);
        return this.baseService.getData(url);
    }

    isPatientHasPerscriptions(ConsultationId) {
        const url = Utility.stringFormat(ConsultationUrl.IS_PATIENT_HAS_PRESCRIPTION, [ConsultationId]);
        return this.baseService.getData(url);
    }
    getLabTestCompleteHistory(ids: any[]) {
        const url = ConsultationUrl.GET_PATIENT_LABTEST_COMPLETED_HISTORY;
        return this.baseService.postData(url, ids);
    }
    getLabTest(ConsultationId) {
        const param = {
            OrderByName: true
        };
        const url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_LABTEST, [ConsultationId]);
        return this.baseService.getData(url, param);
    }

    getPatientDetail(patientId) {
        const url = PatientUrl.GET_PATIENT_ACCOUNT.replace('{id}', patientId);
        return this.baseService.getData(url, null);
    }

    savePatientLabtestTestResult(consultationId, data) {
        let url = Utility.stringFormat(ConsultationUrl.SAVE_PATIENT_LABETEST_TEST_RESULT, [consultationId]);
        return this.baseService.postData(url, data);
      }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/consultation-history.service.ts